import React, { memo, forwardRef } from 'react';
import { FocusScope } from '@react-aria/focus';
import { Opacity, TransitionGroup } from '../transitions';
import { Paper } from '../paper';
import { Overlay } from './Overlay';
import { Backdrop } from './Backdrop';
import { TRANSITION_DURATION } from './consts';
import { ModalContainer } from './ModalContainer';
// хуки модалок react-aria работают так что компонент обязательно должен быть в DOM
// и в нем нельзя написать что-то типа if (!opened) return null
// потому нужен отдельный компонент который отвечает за маунт
function OverlayTransition(props) {
    return (React.createElement(TransitionGroup, { on: !!props.opened },
        React.createElement(Opacity, { duration: TRANSITION_DURATION },
            React.createElement(Overlay, { ...props }))));
}
export const Modal = memo(forwardRef(function Modal({ children, Component = Paper, dismissable, onClose, opened, backdrop, portal, overlay, preventScroll, disableAutoFocus, disableRestoreFocus, enableFocusOutside, size = 'm', ...props }, ref) {
    return (React.createElement(OverlayTransition, { portal: portal, dismissable: dismissable, opened: opened, onClose: onClose, size: size, ...overlay },
        React.createElement(Backdrop, { ...(typeof backdrop === 'boolean' ? { visible: backdrop } : backdrop) },
            React.createElement(FocusScope, { contain: !enableFocusOutside, restoreFocus: !disableRestoreFocus, autoFocus: !disableAutoFocus },
                React.createElement(ModalContainer, { Component: Component, preventScroll: !opened ? false : preventScroll, ...props, ref: ref }, children)))));
}));
